<template>
  <div>
    <a-card class="py-5 mt-5" v-if="rows">
      <div class="container mx-auto text-center">
        <img src="../../../public/task.svg"/>
        <h2>You haven't created any matter.</h2>
        <p class="text-base font-medium">
          Click <a href="#">here</a> or use the button in the bottom to create a new matter.
        </p>
        <a-button color="primary" type="primary" size="large" class="font-bold" @click="addMatter">New Matter</a-button>
      </div>
    </a-card>
    <div v-else>
        <vx-card class="mt-5 overflow-auto vx-card">
          <div class="flex justify-between">
            <div class="text-2xl font-semibold">Matter</div>
            <a-button v-if="hasPermission('matter.create')" type="primary" icon="plus" @click="addMatter" style="border-radius: 3px !important;">New Matter</a-button>
          </div>
          <a-divider/>
          <div class="flex justify-between">
            <a-radio-group v-model="type_matter" button-style="solid" class="self-center" style="white-space: nowrap">
              <a-radio-button value="All" @click="filterStatus('all')">
                All
              </a-radio-button>
              <a-radio-button value="Open" @click="filterStatus(1)">
                Open
              </a-radio-button>
              <a-radio-button value="Closed" @click="filterStatus(2)">
                Closed
              </a-radio-button>
              <a-radio-button value="Pending" @click="filterStatus(3)">
                Pending
              </a-radio-button>
            </a-radio-group>
            <div class="flex items-center gap-2">
              <ChipCustomizeCloseClearChipIcon
                v-if="$refs.matters"
                :items="$route.params.id || filterStorage.length ? [] : $refs.matters.query.query"
                :data="{
                  practice_area: $refs.practiceArea ? $refs.practiceArea.data : [],
                  responsible  : $refs.users        ? $refs.users.data        : [],
                  groups       : $refs.permissions  ? $refs.permissions.data  : [],
                  contacts     : $refs.listContacts ? $refs.listContacts.rows : []
                }"
                @deleteFilter="deleteFilter"
              />
              <a-button type="primary"
                        ghost
                        icon="filter"
                        @click="showDrawer"
                        style="border-radius: 3px !important;"
              >
                <template #icon>
                  <feather-icon icon="FilterIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                </template>
                Filter And Export
              </a-button>
            </div>
          </div>
          <XTable
            :model="model"
            ref="matters"
            :options="options"
            @refresh="refresh"
            @clickRow="(record)=>clickRow(`/matters/edit/${record.id}`,'matter.get')"
            class="mt-10"
          >
          <span slot="title_matter" slot-scope="text,record">
            <a-popover>
              <template slot="content">
                <p>{{ text.record.title }}</p>
              </template>
              <a-button type="link" @click="matterDashboard(text.record)">
                <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem; text-align: left;">
                  {{ text.record.title }}
                </span>
              </a-button>
            </a-popover>
          </span>
            <span slot="client" slot-scope="text,record">
                <template v-if="text.record.client.person">
                  {{ text.record.client.person.first_name }}  {{ text.record.client.person.last_name }}
                </template>
                <template v-else>
                  {{ text.record.client.company.name }}
                </template>
              </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('matter.get')" key="1" @click="toEditItem(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('matter.delete')" key="2" @click="promptDelete(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                      <a-menu-item v-if="hasPermission('note.create')" key="3" @click="addNoteItem(text.record.id)"> <feather-icon icon="Edit3Icon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Add Note</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
                </a-dropdown>
              </span>
            <span slot="status" slot-scope="text,record">
                <template v-if="text.record.status == 1">
                  Open
                </template>
                <template v-if="text.record.status == 2">
                  Closed
                </template>
                <template v-if="text.record.status == 3">
                  Pending
                </template>
              </span>
            <span slot="responsible" slot-scope="text,record">
            <span v-if="!text.record.responsible || text.record.responsible.length === 0"></span>
            <span v-else-if="text.record.responsible.length === 1">
              {{ text.record.responsible[0].first_name }} {{ text.record.responsible[0].last_name }}
            </span>
            <a-popover v-else trigger="click" placement="bottom">
              <template slot="content">
                <ATag v-for="(res,i) in text.record.responsible" :key="i">
                  {{ res.first_name }}  {{ res.last_name }}
                </ATag>
              </template>
              <span>
                {{ text.record.responsible[0].first_name }} {{ text.record.responsible[0].last_name }},
                <a-button type="link" class="pl-0" @click="is_click_add_time = false">more</a-button>
              </span>
            </a-popover>
          </span>
            <span slot="origination" slot-scope="text,record">
            <span v-if="!text.record.origination || text.record.origination.length === 0"></span>
            <span v-else-if="text.record.origination.length === 1">
              {{ text.record.origination[0].first_name }} {{ text.record.origination[0].last_name }}
            </span>
            <a-popover v-else trigger="click" placement="bottom">
              <template slot="content">
                 <template v-if="text.record.origination.length">
                  <ATag v-for="(ori,i) in text.record.origination" :key="i">
                   {{ ori.first_name }}  {{ ori.last_name }}
                  </ATag>
                 </template>
                <template v-else>No origination</template>
              </template>
              <span>
                {{ text.record.origination[0].first_name }} {{ text.record.origination[0].last_name }},
                <a-button type="link" class="pl-0" @click="is_click_add_time = false">more</a-button>
              </span>
            </a-popover>
          </span>
            <span slot="practice_area" slot-scope="text,record" v-if="text.record.practice_area">
                {{ text.record.practice_area.title }}
              </span>
            <span slot="group" slot-scope="text,record" v-if="text.record.group">
            {{ text.record.group.title }}
          </span>
            <span slot="open_date" slot-scope="text,record">
            {{ setDateFormat(text.record.open_date) }}
          </span>
            <span slot="close_date" slot-scope="text,record">
            {{ setDateFormat(text.record.closed_date) }}
          </span>
            <span slot="limitation_date" slot-scope="text,record">
            {{ setDateFormat(text.record.limitation_date) }}
          </span>
          </XTable>
        </vx-card>
    </div>

    <a-modal centered :visible="open_add_note" title="Add Note" :width="700" @cancel="open_add_note = false">
      <a-form :form="form" @submit.prevent="handleNote">
        <div class="flex flex-col md:flex-row">
          <div class="w-full">
            <div class="grid grid-cols-1">
              <a-form-item label="Subject" has-feedback>
                <a-input
                  v-decorator="['title',{ rules: [{ required: true, message: 'Please Enter Title Field.' }] }]"
                  autocomplete="none"
                />
              </a-form-item>
              <a-form-item label="Note" has-feedback>
                <a-textarea
                  v-decorator="['description',{ rules: [{ required: true, message: 'Please Enter description Field.' }] }]"
                  autocomplete="none"
                />
              </a-form-item>

              <selectSearch
                            :required="true"
                            url="/matter/query/"
                            :options="optionSearchMatter"
                            field="matter"
                            label="Matters"
                            class="self-center flex-grow mt-8 md:mt-0 w-full md:w-2/3"
                            :is_include_matter="true"
              />

              <a-form-item label="Date" has-feedback>
                <a-date-picker
                  v-decorator="['date',{ initialValue: current_date,rules: [{ required: true, message: 'Please Enter Date Field.' }] }]"
                  :format="dateFormat"
                  class="w-full md:w-1/3"
                />
              </a-form-item>

              <a-divider/>
              <h4>Recorded time</h4>
              <p>Add a time entry to this note</p>
              <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
                <a-form-item label="Time" has-feedback>
                  <a-input
                    v-decorator="['recorded_time',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
                    placeholder="recorded Time"
                    autocomplete="none"
                    :disabled="!stop_time"
                    addon-after="hour"
                    class="recorded_time"
                  />
                </a-form-item>
                <Timer @Timer="(timing)=>timer(timing,form,'recorded_time')" @startTime="startTime" :time="time" ref="timer" class="timer md:mt-5 md:mt-10"/>
              </div>
              <a-divider/>
              <h4>Notifications</h4>
              <p>Select firm users to receive notifications about this note.</p>
              <SelectOption
                url="/account/list/"
                label="Notification"
                placeholder="notification"
                field="notifications"
                method="get"
                mode="multiple"
              />
            </div>
          </div>
        </div>
        <a-divider/>
        <div class="flex space-x-2">
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
          <a-button type="primary" ghost @click="open_add_note = false" style="border-radius: 3px !important;">Cancel</a-button>
        </div>
      </a-form>
    </a-modal>

    <Drawer
      ref="drawer"
      :form="form"
      :ele="$refs.matters"
      :query="[
                { field : 'title', value: form.getFieldValue('title') , condition:'like'},
                { field : 'client', value: form.getFieldValue('client') , condition: '=' },
                { field : 'practice_area', value: form.getFieldValue('practice_area') , condition: '=' },
                { field : 'responsible', value: form.getFieldValue('responsible') , condition: 'in' },
                { field : 'origination', value: form.getFieldValue('origination') , condition: 'in' },
                { field : 'group', value: form.getFieldValue('group') , condition: '=' },
                { field : 'location', value: form.getFieldValue('location') , condition: 'like' },
                { field : 'reference_code', value: form.getFieldValue('reference_code') , condition: 'like' },
                { field : 'created_at', value: currentDate, condition: '<='},
                { field : 'created_at', value: period_of_time, condition: '>='},
      ]"
    >
        <a-form-item label="Title" has-feedback>
          <input
            v-decorator="['title',{ rules: [{ required: false }] }]"
            placeholder="title"
            autocomplete="none"
            class="ant-input"
          />
        </a-form-item>
        <selectSearch
          ref="listContacts"
          :options="{placeholder: 'Search contacts',label: 'Client',field: 'client',width: '100%',allow_clear: true}"
        />
        <SelectOption ref="practiceArea" url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
        <SelectOption ref="users" url="/account/list/" label="Responsible Lawyer" placeholder="Responsible" field="responsible" method="get" mode="multiple"/>
        <SelectOption ref="users" url="/account/list/" label="Originating Lawyer" placeholder="Originating" field="origination" method="get" mode="multiple"/>
        <SelectOption ref="permissions" url="/account/group/" label="Permissions" placeholder="groups" field="group" method="get" />
        <a-form-item label="Location" has-feedback>
          <input
            v-decorator="['location',{ rules: [{ required: false }] }]"
            placeholder="Location"
            class="ant-input"
            autocomplete="none"
          />
        </a-form-item>
        <a-form-item label="Client reference number" has-feedback>
          <input
            v-decorator="['reference_code',{rules: [{ required: false }] }]"
            placeholder="reference"
            class="ant-input"
            autocomplete="none"
          />
        </a-form-item>
        <a-form-item label="Period Of Time" has-feedback>
          <a-select
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['period_of_time']"
            @select="handleSelectPeriodOfTime"
          >
            <a-select-option value="1,days">
              1 day ago
            </a-select-option>
            <a-select-option value="3,days">
              3 days ago
            </a-select-option>
            <a-select-option value="1,weeks">
              7 days ago
            </a-select-option>
            <a-select-option value="1,months">
              1 month ago
            </a-select-option>
            <a-select-option value="3,months">
              3 months ago
            </a-select-option>
            <a-select-option value="1,years">
              12 months ago
            </a-select-option>
          </a-select>
      </a-form-item>
        <div
          :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 1,
        }"
        >
          <div class="flex gap-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important">
              Save filter
            </a-button>
            <a-button type="primary" ghost @click="exportTbl" :loading="loadingExport" style="border-radius: 3px !important;">
               Export
            </a-button>
          </div>
        </div>
    </Drawer>

    <vs-prompt
      color="danger"
      title="Delete Matter"
      @cancel="active_prompt = false"
      @close="active_prompt = false"
      :active.sync="active_prompt"
      buttons-hidden
    >
      <div class="text-left">
        <div class="font-medium">Are you sure to delete this matter ?</div>
      </div>
      <div class="flex justify-center space-x-3 mt-5">
        <vs-button color="danger" @click="deleteItem">delete</vs-button>
        <vs-button color="danger" type="flat" @click="active_prompt = false">Cancel</vs-button>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableCol from './mattersTbl'
import axios from "@/axios"
import SelectSearch from '../forms/selectSearch'
import SelectOption from '../forms/SelectOptionSingle'
import Timer from "@/layouts/components/timer/Timer";
import Mixin from '../mixin/mixin'
import Drawer from '../drawer/Drawer'
import VueHtml2pdf from 'vue-html2pdf'
import ChipCustomizeCloseClearChipIcon from "@/views/components/vuesax/chip/ChipCustomizeCloseClearChipIcon";

export default {
  name: "Matters",
  mixins: [Mixin],
  props: {
    activeFilter: {
      type: Boolean,
      default: false
    },
    hasFilterContact: {
      type: Boolean,
      default: false
    }
  },
  components:{
    XTable,
    SelectSearch,
    SelectOption,
    Drawer,
    Timer,
    VueHtml2pdf,
    ChipCustomizeCloseClearChipIcon
  },
  data(){
    return{
      model                   : null,
      active_prompt           : false,
      open_add_note           : false,
      current_id              : null,
      area                    : [],
      loading                 : false,
      type_matter             : 'All',
      options                 : {
                                  placeholder:'Search matters',
                                  noContent: 'No matters',
                                  is_row_selection: false,
                                  is_load_req: false
                                },
      order_matter_client_items: [],
      excel: '#'
    }
  },
  methods:{
    async deleteFilter(item){
      try {
        await this.$refs.matters.fetch()
        this.form.resetFields(item.field.includes('__') ? item.field.split('__')[1] : item.field)
      }catch (e) {
        throw new Error(e)
      }
    },

    statusMatter(sts){
      if(sts === 1)
        return {title:'Open',color:'green'}
      else if(sts === 2)
        return {title:'Close',color: 'red'}
      else if(sts === 3)
        return {title:'Pending',color:'yellow'}
    },

    addNoteItem(id){
      this.open_add_note = true
      this.$nextTick(()=>this.form.setFieldsValue({ matter: id }))
    },

    async exportTbl() {
      try{
        this.loadingExport = true
        const columns = this.$refs.matters.cols
        const columns_filtered = columns.filter(
          (item)=> item.key!=="reference_code" && item.key !== "action" && item.show).map(item => ({[item.title]: item.dataIndex }
        ))
        const result = columns_filtered.reduce(function(result, item) {
          let key = Object.keys(item)[0];
          result[key] = item[key];
          return result;
        }, {});
        const {data} = await axios.post('matter/query/',{
            export: true,
            columns: result,
            query: this.$refs.drawer.query.filter((item)=> item.value),
            limit: 1000
          }
        )
        window.open(data.url,'_self')
      }catch (e) {
        this.$message.error('Error')
        throw e
      }finally {
        this.loadingExport = false
      }
    },

    async handleMatterClientReport(){
      try{
        const { data } = await axios.get('/report/stats/matter/index')
        this.order_matter_client_items = data.result
        this.$nextTick(()=>this.order_matter_client_items = data.result.map((item,ind)=>this.$refs['matters_client'][ind].data = item))
      }catch (e) {
        this.$message.error('Server error')
      }
    },

    matterDashboard(record){
      this.is_click_add_time = false
      this.$router.push(`/matters/dashboard/${record.id}`)
      this.$store.commit('DASHBOARD_ID',record.id)
    },

    refresh(){
      this.type_matter = 'All'
    },

    showDrawer(){
       this.$refs.drawer.visible_drawer = true
    },

    async filterStatus(sts){
      this.checkPagenation(this.$refs.matters)
      sts === 'all' ?  this.$refs.matters.query.query = [...this.filterStorage] : this.$refs.matters.query.query = [...this.filterStorage,{ field: 'status',condition: '=',value: sts }]
      await this.$refs.matters.fetch()
    },

    addMatter(){
      this.$router.push('/matters/add')
    },

    toEditItem(id){
      this.$router.push(`/matters/edit/${id}`)
    },

    promptDelete(id){
      this.current_id = id
      this.active_prompt = true
    },

    async deleteItem(){
      try{
        const id = this.current_id
        this.active_prompt = false
        this.$refs.matters.loading = true
        await axios.delete(`/matter/${id}/`)
        await this.$refs.matters.fetch()
        this.$notification['success']({
          message: 'Success',
          description: `Matter deleted.`,
        });
      }catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: `Please try again.`,
        });
      }finally {
        this.$refs.matters.loading = false
      }
    },

    async getPracticeArea(){
      const {data} = await axios.get('/dictionary/practice-area/')
      this.area = data
    },

  },
  computed:{
    rows(){
      if(this.$refs.matters){
        return this.$refs.matters.query
      }
    },
    filterStorage() {
      const user = JSON.parse(localStorage.getItem('user'))
       return (
         [
           { field: 'responsible' , condition: '=' , value: user.id , operation:'or' },
           { field: 'origination' , condition: '=' , value: user.id , operation:'or' },
           { field: 'origination' , condition: '=' , value: null , operation:'or' },
           { field: 'responsible' , condition: '=' , value: null , operation:'or' },
         ]
       )
    }
  },
  async mounted() {
    this.is_click_add_time = true
    this.handleMatterClientReport()
    if (this.$route.params.query) {
      this.$refs.matters.onSearch(this.$route.params.query)
    }
    else if (localStorage.getItem('user')) {
     /// this.$refs.matters.query.query = this.filterStorage
      if (this.hasFilterContact) {
        this.$refs.matters.query.query = [...this.$refs.matters.query.query,{ field: 'client__id', condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
      }
      await this.$refs.matters.fetch()
    }
  },
  created() {
    this.getPracticeArea()
    this.model = TableCol.default
  }
}
</script>

<style>
  @import "../style/style.css";
  [dir=ltr] .ant-modal-footer{
    display: none;
  }
  .matter-add{
    text-align: right;
    display: block;
    margin-left: auto;
  }
  [dir=ltr] .ant-radio-button-wrapper:first-child{
    border-radius: 3px 0 0 3px;
  }
  [dir=ltr] .ant-radio-button-wrapper:last-child{
    border-radius: 0 3px 3px 0;
  }
  [dir] .ant-card-bordered{
    border-radius: 6px;
  }
  [dir] .ant-input, [dir] .ant-calendar-picker-input, [dir] .ant-select-selection {
    border-radius: 3px !important;
  }
  .ant-calendar-picker-input,.ant-select-selection {
    border-radius: 3px !important;
  }
  .vs-button--icon{
    z-index: 10 !important;
  }
  .ant-drawer-content-wrapper {
    z-index: 10000 !important;
  }
  .ant-select-dropdown-menu.ant-select-dropdown-menu-vertical.ant-select-dropdown-menu-root{
    z-index: 200000000 !important;
    position: relative;
  }
  [dir=ltr] .ant-drawer-mask{
    z-index: 1000 !important;
  }
  .x-table-container {
    max-width: 100%;
    overflow-x: auto;
  }

  /* Optional: If you want to set a specific width for the table */
  .x-table-container .ant-table-wrapper {
    width: 100%;
  }
</style>
